module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"apply":"Candidate-se"},"en":{"apply":"Apply"}}')
  delete Component.options._Ctor
}
